import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from "../../environments/environment"
import { UserService } from './user.service';
import { AngularFireDatabase } from '@angular/fire/compat/database';

@Injectable({
    providedIn: 'root'
})

export class SettingService {
    routeName: any;
    public bongCategories = [];
    public productCategories = [];
    type: any;
    bongCategory: any;
    productCategory: any;
    searchedData: Event;
    readonly googleFontOptions: { label: string; value: string }[] = [
        { label: 'Poppins', value: 'Poppins' },
        { label: 'Open Sans', value: 'Open Sans' },
        { label: 'Roboto', value: 'Roboto' },
        { label: 'Inter', value: 'Inter' },
        { label: 'Lato', value: 'Lato' },
        { label: 'Oswald', value: 'Oswald' },
        { label: 'Montserrat', value: 'Montserrat' },
        { label: 'Source Sans 3', value: 'Source Sans 3' },
        { label: 'Nunito', value: 'Nunito' },
        { label: 'Raleway', value: 'Raleway' },
        { label: 'Barlow', value: 'Barlow' },
        { label: 'Work Sans', value: 'Work Sans' },
        { label: 'Ubuntu', value: 'Ubuntu' },
        { label: 'DM Sans', value: 'DM Sans' },
        { label: 'Manrope', value: 'Manrope' },
        { label: 'Plus Jakarta Sans', value: 'Plus Jakarta Sans' },
        { label: 'Figtree', value: 'Figtree' },
        { label: 'Outfit', value: 'Outfit' },
        { label: 'Sora', value: 'Sora' },
        { label: 'Lexend', value: 'Lexend' },
        { label: 'Rubik', value: 'Rubik' },
        { label: 'Quicksand', value: 'Quicksand' },
        { label: 'Karla', value: 'Karla' },
        { label: 'Fira Sans', value: 'Fira Sans' },
        { label: 'PT Sans', value: 'PT Sans' },
        { label: 'Bebas Neue', value: 'Bebas Neue' },
        { label: 'Playfair Display', value: 'Playfair Display' },
        { label: 'Merriweather', value: 'Merriweather' },
        { label: 'Libre Baskerville', value: 'Libre Baskerville' },
        { label: 'Lora', value: 'Lora' },
        { label: 'Crimson Pro', value: 'Crimson Pro' },
        { label: 'Source Serif 4', value: 'Source Serif 4' },
    ];
    constructor(private http: HttpClient, private userService: UserService, private afDatabase: AngularFireDatabase,) {
        this.userService.selectedUnit2$.subscribe(x => {
            if (!x) return;
            this.routeName = x.routeName;
        })
    }
    async getProductCategories(routeName?: string) {
        let body = {
            routeName: routeName || this.routeName
        }
        let url = `${environment.pubQueueApiUrlEU}/v1/units/products/categories/getProductCategories`;
        var result = await this.http.post<ProductTypeChild[]>(url, body).toPromise();
        this.productCategories = result;
        return result;
    }

    async getBongCategories() {
        let body = {
            routeName: this.routeName
        }
        let url = `${environment.pubQueueApiUrlEU}/v1/units/products/categories/getBongCategories`;
        var result = await this.http.post<ProductTypeChild[]>(url, body).toPromise();
        this.bongCategories = result;
        return result;
    }


    /**
     * Coursing (POS2): the unit's own course names (empty: the standard names, translated) and which
     * course each bongcategory's items go into.
     * Kept in the unit's RTDB settings, where POS2 reads them, keyed by the bongcategory's id
     * (InternalId, what products carry in type.bongCategoryType.id). No entry: no course (sent at once).
     */
    async getCoursing(routeName?: string): Promise<{ labels: string[]; bongCategoryCourses: Record<string, number> }> {
        const unit = routeName || this.routeName;
        const value = (await this.afDatabase.database.ref(`adminApp/clients/${unit}/settings/coursing`).once('value')).val() || {};
        const labels = Array.isArray(value.labels) ? value.labels.filter((x: unknown) => typeof x === 'string') : [];
        const bongCategoryCourses: Record<string, number> = {};
        // RTDB hands numeric keys back as an array when it can.
        for (const [id, course] of Object.entries(value.bongCategoryCourses || {})) {
            if (typeof course === 'number' && course > 0) bongCategoryCourses[id] = course;
        }
        return { labels, bongCategoryCourses };
    }

    /** Sets (or with null, clears) the course of a bongcategory's items. */
    async setBongCategoryCourse(categoryId: string, course: number | null, routeName?: string): Promise<void> {
        const unit = routeName || this.routeName;
        if (!unit || categoryId === undefined || categoryId === null || categoryId === '') return;
        await this.afDatabase.database
            .ref(`adminApp/clients/${unit}/settings/coursing/bongCategoryCourses/${categoryId}`)
            .set(course && course > 0 ? course : null);
    }

    async updateCategory(category: ProductTypeChild, type: ("Product" | "Bong")) {
        let body = {
            routeName: this.routeName,
            category: category
        }
        let url = `${environment.pubQueueApiUrlEU}/v1/units/products/categories/update${type}Category`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }

    async addCategory(category: ProductTypeChild, type: string) {
        let body = {
            routeName: this.routeName,
            category: category
        }
        let url = `${environment.pubQueueApiUrlEU}/v1/units/products/categories/add${type}Category`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }

    async deleteCategory(category: ProductTypeChild, type: string) {
        let body = {
            routeName: this.routeName,
            category: category
        }
        let url = `${environment.pubQueueApiUrlEU}/v1/units/products/categories/delete${type}Category`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }


    async createPosUser(user: PosUser) {
        let body = {
            routeName: this.routeName,
            user: user
        }
        let url = `${environment.pubQueueApiUrl}/settings/v1/posUsers/create`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }

    async updatePosUser(user: PosUser) {
        let body = {
            routeName: this.routeName,
            user: user
        }
        let url = `${environment.pubQueueApiUrl}/settings/v1/posUsers/update`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }
    async deletePosUser(user: PosUser) {
        let body = {
            routeName: this.routeName,
            user: user
        }
        let url = `${environment.pubQueueApiUrl}/settings/v1/posUsers/delete`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }

    async getPosUsers(getAllUsers = false) {
        let body = {
            routeName: this.routeName,
            getAllUsers,
        }
        let url = `${environment.pubQueueApiUrl}/settings/v1/posUsers/getActiveUsers`;
        var result = await this.http.post<any>(url, body).toPromise();
        return result;
    }
    async hideChatBubble() {
        if (!window['intercomSettings'] || typeof window['Intercom'] !== 'function') {
            return;
        }
        window['intercomSettings'].hide_default_launcher = true;
        window['Intercom']('update');
    }
    async showChatBubble() {
        if (!window['intercomSettings'] || typeof window['Intercom'] !== 'function') {
            return;
        }
        window['intercomSettings'].hide_default_launcher = false;
        window['Intercom']('update');
    }

    setType(type) {
        this.type = type
    }

    getType() {
        return this.type;
    }
    setproductType(type) {
        this.productCategory = type;
    }

    getproductType() {
        return this.productCategory;
    }
    setbongCategoryType(type) {
        this.bongCategory = type
    }

    getbongCategoryType() {
        return this.bongCategory;
    }

    setSearchedData(data) {
        this.searchedData = data
    }

    getSearchedData() {
        return this.searchedData
    }

    async getButtons(): Promise<any> {
        let res = await this.afDatabase.database.ref(`Clients/${this.routeName}/AppInfo/Context/screen/main`).once("value");
        return res.val()
    }

    async getSingleButtonValues(): Promise<any> {
        let res = await this.afDatabase.database.ref(`Clients/${this.routeName}/AppInfo/Context`).once("value");
        let { customIcon, customIcon2, customIcon3, customIcon4, customUrl, customUrl2, customUrl3, customUrl4, customUrlButtonCustomText, customUrl2ButtonCustomText, customUrl3ButtonCustomText, customUrl4ButtonCustomText } = res.val();

        return { customIcon, customIcon2, customIcon3, customIcon4, customUrl, customUrl2, customUrl3, customUrl4, customUrlButtonCustomText, customUrl2ButtonCustomText, customUrl3ButtonCustomText, customUrl4ButtonCustomText }
    }

    deleteButton(btnId: any) {
        let url = `${environment.pubQueueApiUrlEU}/v1/buttons`;
        return this.http.delete(url + '/' + this.routeName + '/' + btnId);
    }

    publish(data: any) {
        data.routeName = this.routeName;
        let url = `${environment.pubQueueApiUrlEU}/v1/buttons/publish`;
        return this.http.post(url, data);
    }

    getResolvedClientTimeZone(routeName: string): Observable<string> {
        const fallback = getClientTimeZoneFallback(routeName);
        const url = `${environment.pubQueueApiUrl}/settings/v1/getResolvedClientTimeZone`;

        return this.http.post(url, { routeName }, { responseType: 'text' }).pipe(
            map((tz) => {
                const resolved = (tz || '').trim();
                return resolved || fallback;
            }),
            catchError(() => of(fallback)),
        );
    }
}

export function getClientTimeZoneFallback(routeName: string): string {
    const r = routeName.toLowerCase();
    if (r.startsWith('compassfi')) {
        return 'Europe/Helsinki';
    }
    if (r.startsWith('compassdk')) {
        return 'Europe/Copenhagen';
    }
    if (r.startsWith('compassno')) {
        return 'Europe/Oslo';
    }
    if (r.startsWith('compass')) {
        return 'Europe/Stockholm';
    }
    return 'Europe/Stockholm';
}


export interface ProductTypeChild {
    label: string;
    id: string;
    externalId: string;
    productTypeId: string;
    dbId: string;
}

export interface PosUser {
    id: number,
    name: string,
    firstName?: string | null,
    lastName?: string | null,
    pinCode: string,
    active: boolean,
    phoneNumber: string,
    email: string,
    employeeId: string,
    permissions: {
        refund: boolean;
        moveBooking?: boolean;
        editBookingTimeslot?: boolean;
        viewSettings?: boolean;
        editTableMap?: boolean;
        splitTab?: boolean;
        removeFromTab?: boolean;
        maxDiscount: number;
    }
}
